import { CustomGetJobPhaseQuery, JobPhase, useCustomGetJobPhaseQuery } from "generated/graphql";

export type CustomJobPhase = CustomGetJobPhaseQuery["getJobPhase"];

export default function useGetJobPhase({ id }: { id: JobPhase["id"] }) {
  const { loading, data, error } = useCustomGetJobPhaseQuery({ variables: { id } });

  return { loading, data: data?.getJobPhase ?? null, error };
}
